<template>
    <div v-loading="loading">
      <div class="title-top-alarm">
        <div><span>{{homeAddRow.homeTitle}}</span></div>
        <div class="line-title"></div>
      </div>
      <div style="margin: 10px 40px 0px">
        <el-form style="margin-right: 20px" :model="addHomeForm" :rules="addHomeRules" ref="addHomeForm" label-width="90px" class="demo-ruleForm">
          <el-form-item label="家庭/机构" prop="isHome" v-if="moduletag === 3">
            <el-select v-fixZoom @change="changeIsHome" :disabled="!homeAddRow.isAll" style="width: 100%" v-model="addHomeForm.isHome" placeholder="请选择">
              <el-option label="家庭" value="0"></el-option>
              <el-option label="机构" value="1"></el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="联系电话" prop="telephone">
                <el-input v-if="addHomeForm.isHome === '0'" type="number" v-model="addHomeForm.telephone"
                          placeholder="请输入固话 / 家庭成员手机号码"></el-input>
                <el-input v-else-if="addHomeForm.isHome === '1'" type="number" v-model="addHomeForm.telephone"
                          placeholder="请输入固话 / 机构成员手机号码"></el-input>
                <el-input v-else type="number" v-model="addHomeForm.telephone" placeholder="请输入联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item v-if="addHomeForm.isHome === '0'" label="门牌号" prop="address">
                <el-input placeholder="请输入门牌号" v-model="addHomeForm.address" @blur="testAddress()"></el-input>
              </el-form-item>
              <el-form-item v-if="addHomeForm.isHome === '1'" label="房号" prop="address">
                <el-input placeholder="请输入房号" v-model="addHomeForm.address" @blur="testAddress()"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="addHomeForm.isHome === '1'" label="所属机构" prop="cid">
            <el-select v-fixZoom :disabled="!homeAddRow.isAll" style="width: 545px"
                       v-model="addHomeForm.cid" filterable placeholder="请选择机构" @change="changeCommunity">
              <el-option v-for="item in organizationOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" plain icon="el-icon-plus" @click="homeAddCid(addHomeForm.isHome)"></el-button>
          </el-form-item>
          <el-form-item v-if="addHomeForm.isHome === '0'" label="所属小区" prop="cid">
            <el-select v-fixZoom :disabled="!homeAddRow.isAll" style="width: 545px"
                       v-model="addHomeForm.cid" filterable placeholder="请选择小区" @change="changeCommunity">
              <el-option v-for="item in communityOptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
            <el-button type="primary" plain icon="el-icon-plus" @click="homeAddCid(addHomeForm.isHome)"></el-button>
          </el-form-item>
          <div style="text-align: right"><el-button size="mini" type="primary" plain @click="setShow()">设置地图坐标</el-button></div>
          <el-row v-if="isSet" style="margin-top: 20px">
            <el-col :span="12">
              <el-form-item label="经度" prop="lng">
                <el-input style="width: 100%" type="number" v-model="addHomeForm.lng" @blur="sendMarkerLngLat()"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="纬度" prop="lat">
                <el-input style="width: 100%" type="number" v-model="addHomeForm.lat" @blur="sendMarkerLngLat()"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div style="z-index: 9999;margin: 0 10px" v-if="isSet">
          <el-autocomplete v-fixZoom style="width: 100%" class="inline-input" v-model="searchAddress"
                           :fetch-suggestions="querySearch1" placeholder="关键词搜索" :trigger-on-focus="false" @select="handleSelect" @blur="changeAddress"></el-autocomplete>
        </div>
        <div style="margin: -45px 10px 0;height: 300px;" v-if="isSet">
          <iframe v-if="isSet" id="mainIframe1" ref="mainIframe1" name="mainIframe1" style="width: 100%;height: 100%;margin: auto" src="../../../../static/addressMap.html" frameborder="0" scrolling="no"></iframe>
        </div>
        <div style="margin-top: 20px">
          <el-row style="margin: 0 30px">
            <el-col :span="12">
              <div class="cancel-btn" @click="closeAdd()">
                <span>取消</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="send-btn" @click="submitAddHome('addHomeForm')">
                <span>确定</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div style="height: 20px"></div>
      <!--新建小区机构-->
      <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="800px"
        :show-close="true" :close-on-click-modal="false" center top="10vh" class="all-open" append-to-body>
        <community-add-edit v-if="addEditShow" v-model="addEditShow" :commObj="objRow" @getFatherCid="getFatherCid"></community-add-edit>
      </el-dialog>
    </div>
</template>

<script>
import {addorghome} from '../../../api/relation'
import {querycommunitybyorgids} from '../../../api/organizer'
import communityAddEdit from './communityAddEdit'
export default {
  name: 'relationAdd',
  components: {communityAddEdit},
  model: {
    prop: 'addShow',
    event: 'change'
  },
  props: {
    homeAddRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      loading: false,
      mapLnglat: {
        lng: 0,
        lat: 0
      },
      orgid: '',
      organizationOptions: [],
      communityOptions: [],
      allOptions: [],
      addHomeForm: {
        isHome: '',
        id: 0,
        telephone: '',
        address: '',
        orgid: '',
        lng: '',
        lat: '',
        cid: '',
        building: '',
        unit: '',
        room: ''
      },
      addHomeRules: {
        isHome: [{ required: true, message: '请选择添加类型', trigger: 'change' }],
        telephone: [{ required: true, message: '请输入联系方式', trigger: 'blur' }],
        orgid: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        cid: [{ required: true, message: '请选择', trigger: 'change' }],
        address: [{ required: true, message: '请输入', trigger: 'blur' }],
        lng: [{ required: true, message: '请输入', trigger: 'blur' }],
        lat: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      row: '',
      moduletag: '',
      addEditShow: false,
      objRow: {
        type: '',
        openTitle: '',
        orgTree: [],
        orgids: [],
        isAdd: true,
        row: {}
      },
      // 地图
      searchAddress: '',
      map: '',
      autoComplete1: '',
      isSet: false
    }
  },
  created () {
    /* 1、oldPerson.vue 操作服務對象 2、homeManagement.vue家庭管理 3、relation.vue 查看家庭管理弹窗 */
    console.log(this.homeAddRow, this.$store.state.user.moduletag)
    this.moduletag = this.$store.state.user.moduletag
    if (this.moduletag === 1) {
      this.addHomeForm.isHome = '0'
    } else if (this.moduletag === 2) {
      this.addHomeForm.isHome = '1'
    } else {
      this.addHomeForm.isHome = ''
    }
    this.getStartData()
    this.golobleObject.sendIsAdd1 = this.getIsAdd
  },
  mounted () {
  },
  methods: {
    getStartData () {
      this.objRow.orgTree = this.homeAddRow.orgTree
      this.orgid = this.homeAddRow.orgid
      this.addHomeForm.cid = this.homeAddRow.cid
      this.communityOptions = []
      this.organizationOptions = []
      let orgcommunity = this.homeAddRow.orgcommunitys
      if (this.homeAddRow.orgids.length === 0) {
        this.allOptions = this.homeAddRow.orgcommunitys
        for (let i = 0; i < orgcommunity.length; i++) {
          if (orgcommunity[i].zone_type === 1) {
            this.communityOptions.push(orgcommunity[i])
          } else if (orgcommunity[i].zone_type === 2) {
            this.organizationOptions.push(orgcommunity[i])
          }
        }
      } else {
        this.selectOrgId(this.homeAddRow.orgids)
      }
      for (let i = 0; i < orgcommunity.length; i++) {
        if (this.addHomeForm.cid === orgcommunity[i].id) {
          this.addHomeForm.lng = orgcommunity[i].lng
          this.addHomeForm.lat = orgcommunity[i].lat
          this.addHomeForm.orgid = orgcommunity[i].orgid
          this.orgid = orgcommunity[i].orgid
          if (orgcommunity[i].zone_type === 1) {
            this.addHomeForm.isHome = '0'
          } else if (orgcommunity[i].zone_type === 2) {
            this.addHomeForm.isHome = '1'
          }
        }
      }

      this.row = this.homeAddRow.row
      // console.log(this.homeAddRow)
      if (!this.homeAddRow.isAll) { // 小区管理中的家庭管理页面新增家庭
        this.addHomeForm.cid = this.row.id
        this.addHomeForm.lng = this.row.lng
        this.addHomeForm.lat = this.row.lat
        this.addHomeForm.orgid = this.row.orgid
        this.orgid = this.row.orgid
        if (this.row.zone_type === 1) {
          this.addHomeForm.isHome = '0'
        } else if (this.row.zone_type === 2) {
          this.addHomeForm.isHome = '1'
        }
      }
    },
    changeIsHome () {
      this.addHomeForm.cid = ''
    },
    selectOrgId (ids) {
      this.loading = true
      let data = {
        orgids: ids
      }
      querycommunitybyorgids(data).then(res => {
        this.communityOptions = []
        this.organizationOptions = []
        this.allOptions = res.data.communitys
        let orgcommunity = res.data.communitys
        for (let i = 0; i < orgcommunity.length; i++) {
          if (orgcommunity[i].zone_type === 1) {
            this.communityOptions.push(orgcommunity[i])
          } else if (orgcommunity[i].zone_type === 2) {
            this.organizationOptions.push(orgcommunity[i])
          }
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    testAddress () {
      this.addHomeForm.address = this.addHomeForm.address.replace(/[\r\n]/g, '')
    },
    changeCommunity (id) {
      // console.log(id)
      for (let i = 0; i < this.allOptions.length; i++) {
        let item = this.allOptions[i]
        if (id === item.id) {
          this.addHomeForm.cid = item.id
          this.addHomeForm.lng = item.lng
          this.addHomeForm.lat = item.lat
          this.addHomeForm.orgid = item.orgid
        }
      }
      this.sendMarkerLngLat()
    },
    // 新建小区 机构
    homeAddCid (type) {
      this.objRow.type = type
      if (type === '0') {
        this.objRow.openTitle = '新建小区'
      } else if (type === '1') {
        this.objRow.openTitle = '新建机构'
      }
      this.addEditShow = true
    },
    getFatherCid (obj) {
      console.log(obj)
      if (obj.type === 'isHomeAdd') {
        if (obj.communityObj.zone_type === 1) {
          this.communityOptions.push(obj.communityObj)
        } else if (obj.communityObj.zone_type === 2) {
          this.organizationOptions.push(obj.communityObj)
        }
        this.addHomeForm.cidobj = obj.communityObj.id
        this.addHomeForm.cid = obj.communityObj.id
        this.addHomeForm.lng = obj.communityObj.lng
        this.addHomeForm.lat = obj.communityObj.lat
        this.addHomeForm.orgid = obj.communityObj.orgid
      }
      setTimeout(() => {
        if (this.isSet && this.addHomeForm.lng !== 0 && this.addHomeForm.lng !== '' && this.addHomeForm.lat !== 0 && this.addHomeForm.lat !== '') {
          let item = {
            lng: parseFloat(this.addHomeForm.lng),
            lat: parseFloat(this.addHomeForm.lat)
          }
          window.frames['mainIframe1'].window.getParentAddress(item)
        }
      }, 300)
      console.log(this.addHomeForm)
    },
    submitAddHome (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = {
            id: this.addHomeForm.id,
            telephone: this.addHomeForm.telephone,
            address: this.addHomeForm.address,
            orgid: this.addHomeForm.orgid,
            lng: parseFloat(this.addHomeForm.lng),
            lat: parseFloat(this.addHomeForm.lat),
            cid: this.addHomeForm.cid,
            building: this.addHomeForm.building,
            unit: this.addHomeForm.unit,
            room: this.addHomeForm.room
          }
          addorghome(data).then(res => {
            this.$notify({ title: '成功', message: '成功新建家庭/机构', type: 'success', duration: 2000 })
            this.golobleObject.updateTableHome()
            // 服务对象管理 更新数据
            let id = res.data.homeid
            this.golobleObject.addHomeid(id, data.address, data.telephone, data.cid)
            this.$emit('change', false)
          }).catch(() => {
            this.$notify.error({
              title: '失败',
              message: '新建家庭/机构失败'
            })
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    closeAdd () {
      this.$emit('change', false)
    },
    setShow () {
      console.log(999)
      this.isSet = !this.isSet
      setTimeout(() => {
        if (this.addHomeForm.lng !== 0 && this.addHomeForm.lng !== '' && this.addHomeForm.lat !== 0 && this.addHomeForm.lat !== '') {
          let item = {
            lng: parseFloat(this.addHomeForm.lng),
            lat: parseFloat(this.addHomeForm.lat)
          }
          window.frames['mainIframe1'].window.getParentAddress(item)
        }
      }, 300)
    },
    sendMarkerLngLat () {
      if (this.addHomeForm.lng !== 0 && this.addHomeForm.lng !== '' && this.addHomeForm.lat !== 0 && this.addHomeForm.lat !== '') {
        let item = { lng: parseFloat(this.addHomeForm.lng), lat: parseFloat(this.addHomeForm.lat) }
        window.frames['mainIframe1'].window.getParentAddress(item)
      }
    },
    querySearch1 (queryString, cb) {
      this.autoComplete1.search(queryString, function (status, result) {
        let re = []
        if (result.tips) {
          for (let i = 0; i < result.tips.length; i++) {
            let obj = {
              lng: parseFloat(result.tips[i].location.lng),
              lat: parseFloat(result.tips[i].location.lat),
              value: result.tips[i].district + result.tips[i].name
            }
            re.push(obj)
          }
        }
        cb(re)
      })
    },
    handleSelect (item) {
      console.log(item)
      this.addHomeForm.lng = item.lng
      this.addHomeForm.lat = item.lat
      if (this.addHomeForm.address === '') {
        this.addHomeForm.address = item.value
      }
      this.selectMarker(item)
    },
    changeAddress () {
      if (this.addHomeForm.address === '') {
        this.addHomeForm.lng = ''
        this.addHomeForm.lat = ''
      }
    },
    selectMarker (item) {
      window.frames['mainIframe1'].window.getParentAddress(item)
    },
    getIsAdd (obj) {
      console.log('add')
      if (obj.type === 'autoComplete') {
        this.autoComplete1 = obj.autoComplete
        if (this.addHomeForm.lng !== 0 && this.addHomeForm.lng !== '' && this.addHomeForm.lat !== 0 && this.addHomeForm.lat !== '') {
          let item = {
            lng: parseFloat(this.addHomeForm.lng),
            lat: parseFloat(this.addHomeForm.lat)
          }
          window.frames['mainIframe1'].window.getParentAddress(item)
        }
      } else if (obj.type === 'lnglat') {
        this.addHomeForm.lng = obj.lng
        this.addHomeForm.lat = obj.lat
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/childComponents/relationAdd.vue